'use strict';

var Reflux   = require('reflux'),
    _ = require('underscore'),
    defaults = require('superagent-defaults'),
    request  = require('superagent-promise'),
    ApplicationActions = require('js/shared/actions/application-actions.js'),
    formidable = require('formidable');


var TRAVEL = require('js/shared/utils/travel.js');

var request = defaults(request);

var UploadActions = Reflux.createActions({

    uploadFile: { asyncResult: true, children: ['progressed'] },

});

/**
 * Note this has to be seperate due to the defaults(request)
 * if this is used in a file which sets other defaults to request (e.g. top of application-actions)
 * the request will not properly set the content type (expected "multiform/form-data; ....")
 */
UploadActions.uploadFile.listen(function (options) {
    var hackathonSlug = "hackthenorth";
    return request
        .post('https://hackerapi.com/v1/events/' + hackathonSlug + '/upload?token=' + options.token)
        .attach('file', options.file, options.file.name)
        .field('type', options.type)
        .end()
        .then(function (resp) {
            if (resp && resp.success === false) {
                UploadActions.uploadFile.failed([resp, options]);
            }
            else {
                UploadActions.uploadFile.completed([resp, options]);
                ApplicationActions.submitTravelPage(window.app.token, window.app);
            }

        })
        .catch(function(error) {
            UploadActions.uploadFile.failed([error, options]);
        });
});


module.exports = UploadActions;



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/actions/upload-actions.js
 ** module id = 259
 ** module chunks = 0 1
 **/